import { auth } from "./firebase";

// Sign Up
export const doCreateUserWithEmailAndPassword = (email, password) =>
  auth.createUserWithEmailAndPassword(email, password);

// Sign In
export const doSignInWithEmailAndPassword = async (email, password) => {
  const userCredential = await auth.signInWithEmailAndPassword(email, password);
  const userToken = await userCredential.user.getIdToken(false);
  const canLogin = await fetch("/api/admin-user", {
    method: "GET",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${userToken}`,
    },
  })
    .then((res) => res.json())
    .then(({ allowed }) => allowed);

  if (!canLogin) {
    await auth.signOut();
    throw new Error("Unauthorized user");
  }

  return userCredential;
};

// Sign out
export const doSignOut = () => auth.signOut();

// Password Reset
export const doPasswordReset = (email) => auth.sendPasswordResetEmail(email);

// Password Change
export const doPasswordUpdate = (password) =>
  auth.currentUser.updatePassword(password);
